import translate from "src/functions/translate";

function calcDuration(duration: number, lang: string): string {
  let time = duration ? duration : 0; // in seconds
  let hours = Math.floor(time / (60 * 60));
  let minutes = Math.floor((time % (60 * 60)) / 60);
  let durationValue = "";
  if (time > 60) {
    hours > 0 && (durationValue = `${hours} ${translate(`hrs`, lang)}`),
      minutes > 0 &&
        (durationValue += ` ${minutes} ${translate(`mins`, lang)}`);
    return durationValue;
  } else {
    return `${minutes} ${translate(`min.`, lang)}`;
  }
}

export default calcDuration;
